import { Field, Stack, Tag } from "@introist/react-foundation/v2";
import { TextInput } from "components/atoms";
import { StepEditorAccordion } from "../../workflows/routes/WorkflowEditor/StepEditorAccordion";
import { ReadOnlyHTMLEditor } from "./ReadOnlyHTMLEditor";

interface ReadOnlyMessageProps {
  subject?: string;
  message: string;
  opens?: { openedAt: string }[];
}

export const ReadOnlyMessage = ({ subject, message, opens }: ReadOnlyMessageProps) => {
  return (
    <StepEditorAccordion title="Message">
      <Stack vertical>
        {subject && <TextInput readOnly value={subject} label="Subject" size="small" />}
        {subject && (
          <Field title="Message">
            <ReadOnlyHTMLEditor html={message} />
          </Field>
        )}
        {!subject && <ReadOnlyHTMLEditor html={message} />}
        {opens !== undefined && (
          <div style={{ alignSelf: "flex-start" }}>
            <Tag colorVariant={opens.length > 0 ? "success" : "outlined"}>
              {opens.length > 0 ? "Opened" : "Not opened"}
            </Tag>
          </div>
        )}
      </Stack>
    </StepEditorAccordion>
  );
};
